/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("cy", {
  Redo: "Ailwneud",
  Undo: "Dadwneud",
  Cut: "Torri",
  Copy: "Cop\u00efo",
  Paste: "Gludo",
  "Select all": "Dewis popeth",
  "New document": "Dogfen newydd",
  Ok: "Iawn",
  Cancel: "Canslo",
  "Visual aids": "Cymorth gweledol",
  Bold: "Bras",
  Italic: "Italig",
  Underline: "Tanlinellu",
  Strikethrough: "Llinell drwodd",
  Superscript: "Uwchsgript",
  Subscript: "Is-sgript",
  "Clear formatting": "Clirio pob fformat",
  "Align left": "Aliniad chwith",
  "Align center": "Aliniad canol",
  "Align right": "Aliniad de",
  Justify: "Unioni",
  "Bullet list": "Rhestr fwled",
  "Numbered list": "Rhestr rifol",
  "Decrease indent": "Lleihau mewnoliad",
  "Increase indent": "Cynyddu mewnoliad",
  Close: "Cau",
  Formats: "Fformatau",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Dyw eich porwr ddim yn cynnal mynediad uniongyrchol i'r clipfwrdd. Yn hytrach defnyddiwch y bysellau llwybrau byr Ctrl+X/C/V.",
  Headers: "Penawdau",
  "Header 1": "Pennawd 1",
  "Header 2": "Pennawd 2",
  "Header 3": "Pennawd 3",
  "Header 4": "Pennawd 4",
  "Header 5": "Pennawd 5",
  "Header 6": "Pennawd 6",
  Headings: "Penawdau",
  "Heading 1": "Pennawd 1",
  "Heading 2": "Pennawd 2",
  "Heading 3": "Pennawd 3",
  "Heading 4": "Pennawd 4",
  "Heading 5": "Pennawd 5",
  "Heading 6": "Pennawd 6",
  Preformatted: "Wedi ei rag-fformatio",
  Div: "Div",
  Pre: "Pre",
  Code: "Cod",
  Paragraph: "Paragraff",
  Blockquote: "Dyfyniad Bloc",
  Inline: "Mewnlin",
  Blocks: "Blociau",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Mae gludo nawr yn gweithio yn y modd testun plaen.  Caiff testun plaen ei ludo nawr tan gaiff yr opsiwn ei doglo i'w ddiffodd.",
  Fonts: "Ffontau",
  "Font Sizes": "Meintiau Ffont",
  Class: "Dosbarth",
  "Browse for an image": "Pori am ddelwedd",
  OR: "NEU",
  "Drop an image here": "Gollwng delwedd yma",
  Upload: "Uwchlwytho",
  Block: "Bloc",
  Align: "Alinio",
  Default: "Diofyn",
  Circle: "Cylch",
  Disc: "Disg",
  Square: "Sgw\u00e2r",
  "Lower Alpha": "Alffa Is",
  "Lower Greek": "Groeg Is",
  "Lower Roman": "Rhufeinig Is",
  "Upper Alpha": "Alffa Uwch",
  "Upper Roman": "Rhufeinig Uwch",
  "Anchor...": "Angor...",
  Name: "Enw",
  Id: "Id",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "Dylai Id gychwyn gyda llythyren ac yna dim ond llythrennau, rhifau, llinellau toriad,dotiau, colonau neu danlinellau.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Mae newidiadau heb eu cadw - ydych chi wir am symud i ffwrdd?",
  "Restore last draft": "Adfer y drafft olaf",
  "Special character...": "Nod arbennig...",
  "Source code": "Cod gwreiddiol",
  "Insert/Edit code sample": "Mewnosod/golygu sampl cod",
  Language: "Iaith",
  "Code sample...": "Sampl cod...",
  "Color Picker": "Dewisydd Lliw",
  R: "C",
  G: "Gw",
  B: "Gl",
  "Left to right": "Chwith i'r dde",
  "Right to left": "De i'r chwith",
  "Emoticons...": "Gwenogluniau...",
  "Metadata and Document Properties": "Metaddata a Priodweddau'r ddogfen",
  Title: "Teitl",
  Keywords: "Allweddeiriau",
  Description: "Disgrifiad",
  Robots: "Robotiaid",
  Author: "Awdur",
  Encoding: "Amgodiad",
  Fullscreen: "Sgrin llawn",
  Action: "Gweithred",
  Shortcut: "Llwybr Byr",
  Help: "Help",
  Address: "Cyfeiriad",
  "Focus to menubar": "Ffocws i'r bar dewislen",
  "Focus to toolbar": "Ffocws i'r bar offer",
  "Focus to element path": "Ffocws i lwybr elfen",
  "Focus to contextual toolbar": "Ffocws i far offer y cyd-destun",
  "Insert link (if link plugin activated)":
    "Mewnosod dolen (os yw'r ategyn dolen yn weithredol)",
  "Save (if save plugin activated)": "Cadw (os yw'r ategyn cadw yn weithredol)",
  "Find (if searchreplace plugin activated)":
    "Canfod (os yw'r ategyn chwilio ac amnewid yn weithredol)",
  "Plugins installed ({0}):": "Ategio wedi eu gosod ({0}):",
  "Premium plugins:": "Ategion premiwm:",
  "Learn more...": "Dysgu Mwy...",
  "You are using {0}": "Rydych yn defnyddio {0}",
  Plugins: "Ategion",
  "Handy Shortcuts": "Llwybrau byr cyfleus",
  "Horizontal line": "Llinell lorweddol",
  "Insert/edit image": "Mewnosod/golygu delwedd",
  "Image description": "Disgrifiad y ddelwedd",
  Source: "Ffynhonnell",
  Dimensions: "Dimensiynau",
  "Constrain proportions": "Gorfodi cyfrannedd",
  General: "Cyffredinol",
  Advanced: "Uwch",
  Style: "Arddull",
  "Vertical space": "Gofod fertigol",
  "Horizontal space": "Gofod llorweddol",
  Border: "Border",
  "Insert image": "Mewnosod delwedd",
  "Image...": "Delwedd...",
  "Image list": "Rhestr delweddau",
  "Rotate counterclockwise": "Troi gwrthgloc",
  "Rotate clockwise": "Troi clocwedd",
  "Flip vertically": "Fflipio fertigol",
  "Flip horizontally": "Fflipio llorweddol",
  "Edit image": "Golygu delwedd",
  "Image options": "Dewisiadau delwedd",
  "Zoom in": "Chwyddo mewn",
  "Zoom out": "Chwyddo allan",
  Crop: "Tocio",
  Resize: "Ailfeintio",
  Orientation: "Cyfeiriadaeth",
  Brightness: "Disgleirdeb",
  Sharpen: "Hogi",
  Contrast: "Cyferbynnedd",
  "Color levels": "Lefelau Lliw",
  Gamma: "Gamma",
  Invert: "Gwrthdroi",
  Apply: "Rhoi ar waith",
  Back: "Nol",
  "Insert date/time": "Mewnosod dyddiad/amser",
  "Date/time": "Dyddiad/amser",
  "Insert/Edit Link": "Mewnosod/Golygu dolen",
  "Insert/edit link": "Mewnosod/golygu dolen",
  "Text to display": "Testun i'w ddangos",
  Url: "Url",
  "Open link in...": "Agor dolen yn...",
  "Current window": "Ffenestr gyfredol",
  None: "Dim",
  "New window": "Ffenest newydd",
  "Remove link": "Tynnu dolen",
  Anchors: "Angorau",
  "Link...": "Dolen...",
  "Paste or type a link": "Pastio neu deipio dolen",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "Mae'n debyg mai cyfeiriad e-bost yw'r URL hwn. Ydych chi am ychwanegu'r rhagddoddiad mailto:?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "Mae'n debyg mai dolen allanol yw'r URL hwn. Ydych chi am ychwanegu'r rhagddodiad http:// ?",
  "Link list": "Rhestr dolenni",
  "Insert video": "Mewnosod fideo",
  "Insert/edit video": "Mewnosod/golygu fideo",
  "Insert/edit media": "Mewnosod/golygu cyfrwng",
  "Alternative source": "Ffynhonnell amgen",
  "Alternative source URL": "Ffynhonnell URL arall",
  "Media poster (Image URL)": "Poster cyfrwng (URL delwedd)",
  "Paste your embed code below:": "Gludwch eich cod mewnosod isod:",
  Embed: "Mewnosod",
  "Media...": "Cyfrwng...",
  "Nonbreaking space": "Bwlch heb dorri",
  "Page break": "Toriad tudalen",
  "Paste as text": "Gludo fel testun",
  Preview: "Rhagolwg",
  "Print...": "Argraffu...",
  Save: "Cadw",
  Find: "Chwilio",
  "Replace with": "Amnewid gyda",
  Replace: "Amnewid",
  "Replace all": "Amnewid y cwbl",
  Previous: "Blaenorol",
  Next: "Nesaf",
  "Find and replace...": "Chwilio ac amnewid",
  "Could not find the specified string.": "Methu ffeindio'r llinyn hwnnw.",
  "Match case": "Cas yn cyfateb",
  "Find whole words only": "Canfod geiriau llawn yn unig",
  "Spell check": "Gwirwr sillafu",
  Ignore: "Anwybyddu",
  "Ignore all": "Amwybyddu pob",
  Finish: "Gorffen",
  "Add to Dictionary": "Adio i'r Geiriadur",
  "Insert table": "Mewnosod tabl",
  "Table properties": "Priodweddau tabl",
  "Delete table": "Dileu'r tabl",
  Cell: "Cell",
  Row: "Rhes",
  Column: "Colofn",
  "Cell properties": "Priodweddau'r gell",
  "Merge cells": "Cyfuno celloedd",
  "Split cell": "Hollti celloedd",
  "Insert row before": "Mewnosod rhes cyn",
  "Insert row after": "Mewnosod rhes ar \u00f4l",
  "Delete row": "Dileu rhes",
  "Row properties": "Priodweddau rhes",
  "Cut row": "Torri rhes",
  "Copy row": "Cop\u00efo rhes",
  "Paste row before": "Gludo rhes cyn",
  "Paste row after": "Gludo rhes ar \u00f4l",
  "Insert column before": "Mewnosod colofn cyn",
  "Insert column after": "Mewnosod colofn ar \u00f4l",
  "Delete column": "Dileu colofn",
  Cols: "Colofnau",
  Rows: "Rhesi",
  Width: "Lled",
  Height: "Uchder",
  "Cell spacing": "Bylchiad celloedd",
  "Cell padding": "Padio celloedd",
  "Show caption": "Dangos capsiwn",
  Left: "Chwith",
  Center: "Canol",
  Right: "De",
  "Cell type": "Math y gell",
  Scope: "Cwmpas",
  Alignment: "Aliniad",
  "H Align": "Aliniad Ll",
  "V Align": "Aliniad F",
  Top: "Brig",
  Middle: "Canol",
  Bottom: "Gwaelod",
  "Header cell": "Cell bennawd",
  "Row group": "Gr\u0175p rhes",
  "Column group": "Gr\u0175p colofn",
  "Row type": "Math y rhes",
  Header: "Pennyn",
  Body: "Corff",
  Footer: "Troedyn",
  "Border color": "Lliw Border",
  "Insert template...": "Mewnosod templed...",
  Templates: "Templedi",
  Template: "Templed",
  "Text color": "Lliw testun",
  "Background color": "Lliw cefndir",
  "Custom...": "Personol...",
  "Custom color": "Lliw personol",
  "No color": "Dim Lliw",
  "Remove color": "Tynnu lliw",
  "Table of Contents": "Tabl Cynnwys",
  "Show blocks": "Dangos blociau",
  "Show invisible characters": "Dangos nodau anweledig",
  "Word count": "Cyfri geiriau",
  Count: "Cyfrif",
  Document: "Dogfen",
  Selection: "Dewis",
  Words: "Geiriau",
  "Words: {0}": "Geiriau: {0}",
  "{0} words": "{0} o eiriau",
  File: "Ffeil",
  Edit: "Golygu",
  Insert: "Mewnosod",
  View: "Dangos",
  Format: "Fformat",
  Table: "Tabl",
  Tools: "Offer",
  "Powered by {0}": "Gyrrir gan {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Ardal Testun Uwch. Pwyswch ALT-F9 ar gyfer y ddewislen, Pwyswch ALT-F10 ar gyfer y bar offer. Pwyswch ALT-0 am gymorth",
  "Image title": "Teitl delwedd",
  "Border width": "Lled border",
  "Border style": "Steil border",
  Error: "Gwall",
  Warn: "Rhybuddio",
  Valid: "Dilys",
  "To open the popup, press Shift+Enter":
    "I agor y llamlen, pwyswch Shift+Enter",
  "Rich Text Area. Press ALT-0 for help.":
    "Ardal testun cyfoethog. Pwyswch ALT-0 am help.",
  "System Font": "Ffont system",
  "Failed to upload image: {0}": "Wedi methu uwchlwytho'r ddelwedd: {0}",
  "Failed to load plugin: {0} from url {1}":
    "Wedi methu llwytho'r ategyn: {0} o'r url {1}",
  "Failed to load plugin url: {0}": "Wedi methu llwytho url yr ategyn: {0}",
  "Failed to initialize plugin: {0}": "Wedi methu ymgychwyn yr ategyn: {0}",
  example: "enghraifft",
  Search: "Chwilio",
  All: "Y cwbl",
  Currency: "Arian cyfred",
  Text: "Testun",
  Quotations: "Dyfyniadau",
  Mathematical: "Mathemategol",
  "Extended Latin": "Lladin estynedig",
  Symbols: "Symbolau",
  Arrows: "Saethau",
  "User Defined": "Diffinir gan y defnyddiwr",
  "dollar sign": "Arwydd dolar",
  "currency sign": "Arwydd arian cyfred",
  "euro-currency sign": "Arwydd euro",
  "colon sign": "Arwydd colon",
  "cruzeiro sign": "Arwydd cruzeiro",
  "french franc sign": "Arwydd ffranc Ffrengig",
  "lira sign": "Arwydd lira",
  "mill sign": "arwydd mill",
  "naira sign": "arwydd naira",
  "peseta sign": "arwydd peseta",
  "rupee sign": "arwydd rupee",
  "won sign": "arwydd won",
  "new sheqel sign": "arwydd sheqel newydd",
  "dong sign": "arwydd dong",
  "kip sign": "arwydd kip",
  "tugrik sign": "arwydd tugrik",
  "drachma sign": "arwydd drachma",
  "german penny symbol": "arwydd ceiniog almaenig",
  "peso sign": "arwydd peso",
  "guarani sign": "arwydd quarani",
  "austral sign": "arwydd austral",
  "hryvnia sign": "arwydd hryvnia",
  "cedi sign": "arwydd cedi",
  "livre tournois sign": "arwydd punt tournois",
  "spesmilo sign": "arwydd spesmilo",
  "tenge sign": "arwydd tenge",
  "indian rupee sign": "arwydd rupee india",
  "turkish lira sign": "arwydd lira twrcaidd",
  "nordic mark sign": "arwydd marc nordig",
  "manat sign": "arwydd manat",
  "ruble sign": "arwydd ruble",
  "yen character": "nod yen",
  "yuan character": "nod yuan",
  "yuan character, in hong kong and taiwan": "nod yuan yn Hong Kong a Taiwan",
  "yen/yuan character variant one": "nod yen/yuan amrywiad un",
  "Loading emoticons...": "Yn llwytho gwenogluniau",
  "Could not load emoticons": "Wedi methu llwytho gwenogluniau",
  People: "Pobl",
  "Animals and Nature": "Anifeiliaid a Natur",
  "Food and Drink": "Bwyd a Diod",
  Activity: "Gweithgaredd",
  "Travel and Places": "Teithio a lleoedd",
  Objects: "Gwrthrychau",
  Flags: "Baneri",
  Characters: "Nodau",
  "Characters (no spaces)": "Nodau (dim gofod)",
  "{0} characters": "{0} nod",
  "Error: Form submit field collision.":
    "Gwall: Gwrthdrawiad maes cyflwyno ffurflen",
  "Error: No form element found.": "Gwall: Ni chafwyd elfen ffurflen",
  Update: "Diweddaru",
  "Color swatch": "Casgliad lliwiau",
  Turquoise: "Gwyrddlas",
  Green: "Gwyrdd",
  Blue: "Glas",
  Purple: "Porffor",
  "Navy Blue": "Dulas",
  "Dark Turquoise": "Gwyrddlas tywyll",
  "Dark Green": "Gwyrdd tywyll",
  "Medium Blue": "Glas canolig",
  "Medium Purple": "Porffor canolig",
  "Midnight Blue": "Glas y nos",
  Yellow: "Melyn",
  Orange: "Oren",
  Red: "Coch",
  "Light Gray": "Llwyd golau",
  Gray: "d",
  "Dark Yellow": "Melyn tywyll",
  "Dark Orange": "Oren tywyll",
  "Dark Red": "Coch tywyll",
  "Medium Gray": "Llwyd canolig",
  "Dark Gray": "Llwyd tywyll",
  "Light Green": "Gwyrdd Golau",
  "Light Yellow": "Melyn Golau",
  "Light Red": "Coch Golau",
  "Light Purple": "Porffor Golau",
  "Light Blue": "Glas Golau",
  "Dark Purple": "Porffor Tywyll",
  "Dark Blue": "Glas Tywyll",
  Black: "Du",
  White: "Gwyn",
  "Switch to or from fullscreen mode": "Newid i neu o'r modd sgr\u00een llawn",
  "Open help dialog": "Agor y ddeialog gymorth",
  history: "hanes",
  styles: "steiliau",
  formatting: "fformatio",
  alignment: "aliniad",
  indentation: "mewnoli",
  "permanent pen": "pen sefydlog",
  comments: "Sylwadau",
  "Format Painter": "Brwsh Fformat",
  "Insert/edit iframe": "Mewnosod/golygu iframe",
  Capitalization: "Priflythrennu",
  lowercase: "llythrennau bach",
  UPPERCASE: "Priflythrennau",
  "Title Case": "Priflythyren i bob gair",
  "Permanent Pen Properties": "Priodweddau Yswgrifbin Parhaol",
  "Permanent pen properties...": "Priodweddau ysgrifbin parhaol...",
  Font: "Ffont",
  Size: "Maint",
  "More...": "Mwy...",
  "Spellcheck Language": "Iaith Gwirio Sillafu",
  "Select...": "Dewis...",
  Preferences: "Dewisiadau",
  Yes: "Iawn",
  No: "Na",
  "Keyboard Navigation": "Llywio Bysellfwrdd",
  Version: "Fersiwn",
  Anchor: "Angor",
  "Special character": "Nod arbennig",
  Color: "Lliw",
  Emoticons: "Gwenogluniau",
  "Document properties": "Priodweddau'r ddogfen",
  Image: "Delwedd",
  "Insert link": "Mewnosod dolen",
  Link: "Dolen",
  Target: "Targed",
  Media: "Cyfrwng",
  Poster: "Poster",
  Print: "Argraffu",
  "Whole words": "Geiriau cyfan",
  "Find and replace": "Chwilio ac amnewid",
  Prev: "Blaenorol",
  Spellcheck: "Sillafydd",
  Caption: "Pennawd",
  "Insert template": "Mewnosod templed",
});
